// Platte tekst uit een notitie halen, in de browser.
//
// De server doet dit ook (server/kern/inhoud.ts) voor de zoekindex; hier is het nodig voor de
// spiegel op dit apparaat: zonder netwerk maken we zelf de fragmenten in de lijst en zoeken we
// zelf door de tekst. Bewust een kleine eigen versie en geen gedeelde module: de server bouwt
// hier een FTS-index mee op, en die twee hoeven niet aan elkaar vast te zitten.

import type { Blok } from "./api.ts";

/** Blokken die op hun eigen regel horen; de rest loopt door in de zin. */
const BLOKKEN = new Set([
  "paragraph",
  "heading",
  "codeBlock",
  "blockquote",
  "listItem",
  "taskItem",
  "tableRow",
  "horizontalRule"
]);

export function naarTekst(doc: Blok | null | undefined): string {
  if (!doc) return "";
  const regels: string[] = [];

  const loop = (knoop: Blok, regel: string[]) => {
    if (knoop.type === "text") {
      regel.push(knoop.text ?? "");
      return;
    }
    // De titel van de notitie waarnaar verwezen wordt telt mee: zo vind je een notitie ook
    // via een verwijzing ernaartoe.
    if (knoop.type === "notitieLink") {
      regel.push(String(knoop.attrs?.titel ?? ""));
      return;
    }
    if (knoop.type === "hardBreak") {
      regel.push(" ");
      return;
    }
    const eigenRegel = BLOKKEN.has(knoop.type);
    const doel = eigenRegel ? [] : regel;
    for (const kind of knoop.content ?? []) loop(kind, doel);
    if (eigenRegel) {
      const tekst = doel.join("").trim();
      if (tekst) regels.push(tekst);
    }
  };

  loop(doc, []);
  return regels.join("\n");
}

/** Een kort stukje tekst voor in de lijst, zoals de server het ook meestuurt. */
export function fragmentVan(doc: Blok | null | undefined, lengte = 160): string {
  return naarTekst(doc).replace(/\s+/g, " ").trim().slice(0, lengte);
}
